import { Form, InputNumber } from "antd";
import React, { FC } from "react";

export const SubmissionWinnersField: FC = () => (
  <Form.Item name="maxWinners" label="Number of winners" initialValue={1}>
    <InputNumber min={1} className="w-full" />
  </Form.Item>
);
